import React, { Fragment } from 'react';
import { differenceInDays } from 'date-fns';

import { LifecycleChangeType } from 'app/entities/VersionLifecycle/types';

import Done from './Done';
import Error from '../Error';
import Progress from './Progress';

type Props = {
  error?: { messages: string[] };
  hasError: boolean;
  integrationId: ID;
  isMigrated: boolean;
  isPending: boolean;
  migrationDate?: number;
  migrationId: string;
  versionFrom?: string;
  versionTo?: string;
};

function Migration(props: Props) {
  const {
    error,
    hasError,
    integrationId,
    isMigrated,
    isPending,
    migrationDate,
    migrationId,
    versionFrom,
    versionTo,
  } = props;

  const shouldRenderErrorCTA = hasError;
  const shouldRenderDoneCTA =
    !hasError &&
    isMigrated &&
    migrationDate &&
    differenceInDays(Date.now(), migrationDate) <= 60;
  const shouldRenderProgressCTA =
    !hasError && isPending && versionFrom && versionTo;

  return (
    <Fragment>
      {shouldRenderErrorCTA && (
        <Error
          error={error}
          integrationId={integrationId}
          type={LifecycleChangeType.migrate}
        />
      )}
      {shouldRenderDoneCTA && (
        <Done integrationId={integrationId} persistId={migrationId} />
      )}
      {shouldRenderProgressCTA && (
        <Progress versionFrom={versionFrom} versionTo={versionTo} />
      )}
    </Fragment>
  );
}

export default Migration;
